(function() { module.exports = this["wp"]["escapeHtml"]; }());